var React = require('react');

function IconGuarantee (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11.5001","cy":"12.6572","r":"6.24286","fill":"white","key":0}),React.createElement("path",{"d":"M7.88574 13.2553L10.626 15.9955L17.5852 9.04297","stroke":"#005646","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M11.5 1.551L21.3428 4.73444V13.4364C21.3428 17.2632 18.9921 20.7222 15.3033 22.211C15.303 22.2111 15.3026 22.2113 15.3023 22.2114L11.5 23.7368L7.69763 22.2114C7.69731 22.2113 7.697 22.2112 7.69669 22.211C4.00785 20.7222 1.6571 17.2632 1.6571 13.4364V4.73444L11.5 1.551Z","stroke":"#005646","strokeWidth":"2","key":2})]);
}

IconGuarantee.defaultProps = {"width":"23","height":"25","viewBox":"0 0 23 25","fill":"none"};

module.exports = IconGuarantee;

IconGuarantee.default = IconGuarantee;
